import { PlatformAuth, Profile } from "@sinclair-digital/cabin-auth-library";
import { createContext, useEffect, useState } from "react";
import { gaSetUserId } from "../utils/gtag";

export interface AuthContext {
	isAuthenticated: boolean;
	userProfile: Profile | null;
	platformAuth: PlatformAuth | null;
}

export const AuthContext = createContext<AuthContext>({
	isAuthenticated: false,
	userProfile: null,
	platformAuth: null,
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [userProfile, setUserProfile] = useState<Profile | null>(null);
	const [platformAuth, setPlatformAuth] = useState<PlatformAuth | null>(null);

	useEffect(() => {
		const auth = new PlatformAuth(true, false, false, "int");

		async function checkAuth() {
			const isAuthenticated = (await auth.isAuthenticated()) ?? false;
			setIsAuthenticated(isAuthenticated);
			if (isAuthenticated) {
				const userInfo = await auth.getUser();
				setUserProfile(userInfo);
				gaSetUserId(userInfo?.accountId || null);
			}
		}

		checkAuth();
		setPlatformAuth(auth);
	}, []);

	return (
		<AuthContext.Provider value={{ isAuthenticated, userProfile, platformAuth: platformAuth }}>
			{children}
		</AuthContext.Provider>
	);
}
